import { render, staticRenderFns, recyclableRender, components } from "./uni-badge.vue?vue&type=template&id=26a60cd2&scoped=true&"
var renderjs
import script from "./uni-badge.vue?vue&type=script&lang=js&"
export * from "./uni-badge.vue?vue&type=script&lang=js&"
import style0 from "./uni-badge.vue?vue&type=style&index=0&id=26a60cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a60cd2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-badge/uni-badge.vue"
export default component.exports